import { GeneratorSchemaBase } from '../../types';

export type NgZenGeneratorSchema = GeneratorSchemaBase;
